import { useModal } from 'modals';

import Text from '@cartwhl/ui/base/TextNew';
import Button from '@cartwhl/ui/input/Button';

import { pageFrame } from '../page-frame';
import { publicPageGutters } from '../public-page-gutters';
import ModelIntro from './ModelIntro';
import {
  ActionCard,
  CapabilityCard,
  ModelCard,
  SectionLabel,
} from './components';
import { swingContent } from './content';

export default function SwingPage() {
  const { open } = useModal();

  return (
    <div className={pageFrame}>
      <ModelIntro intro={swingContent.intro} model="swing" />
      <section
        className={`border-primary flex flex-col gap-10 border-b py-10 sm:gap-20 sm:py-20 ${publicPageGutters}`}
      >
        <SectionLabel>Models</SectionLabel>
        <div className="grid gap-6 min-[960px]:grid-cols-2 min-[960px]:gap-10">
          {swingContent.models.map((card) => (
            <ModelCard key={card.id} card={card} columns="two" />
          ))}
        </div>
      </section>
      <section className={`border-primary border-b py-20 ${publicPageGutters}`}>
        <Text
          as="h2"
          token={{
            base: 'display/32/bold',
            sm: 'display/40/bold',
            lg: 'display/56/bold',
            xl: 'display/64/bold',
            '2xl': 'display/88/bold',
          }}
          leading="editorial"
          className="max-w-[1320px] text-pretty"
        >
          Human motion on demand,{' '}
          <span className="text-green">at any scale</span>
        </Text>
      </section>
      <section
        className={`border-primary flex flex-col gap-10 border-b py-10 sm:gap-20 sm:py-20 ${publicPageGutters}`}
      >
        <SectionLabel>Capabilities</SectionLabel>
        <div className="grid gap-6 min-[960px]:grid-cols-2 min-[960px]:gap-10 min-[1360px]:grid-cols-3">
          {swingContent.capabilities.map((capability) => (
            <CapabilityCard
              key={capability.id}
              capability={capability}
              mediaClassName="aspect-video"
            />
          ))}
        </div>
      </section>
      <section
        className={`border-primary flex flex-col gap-10 border-b py-10 sm:gap-20 sm:py-20 ${publicPageGutters}`}
      >
        <div className="flex max-w-[648px] flex-col gap-10">
          <SectionLabel>{swingContent.action.title}</SectionLabel>
          <Text
            as="p"
            token="24"
            leading="editorial"
            className="text-secondary text-pretty"
          >
            {swingContent.action.description}
          </Text>
        </div>
        <div className="grid gap-6 min-[960px]:grid-cols-2 min-[960px]:gap-10 min-[1360px]:grid-cols-3">
          {swingContent.action.cards.map((card) => (
            <ActionCard key={card.id} {...card} />
          ))}
        </div>
        <article className="bg-secondary flex flex-col items-start gap-6 rounded-2xl p-6 xl:p-8 2xl:p-12">
          <Text
            as="h3"
            token={{ base: '24', '2xl': '28' }}
            leading="editorial"
            className="text-pretty"
          >
            {swingContent.action.custom.title}
          </Text>
          <Text
            as="p"
            token="16"
            leading="editorial"
            className="text-secondary max-w-[784px] text-pretty tracking-[-0.02em]"
          >
            {swingContent.action.custom.description}
          </Text>
          <Button
            type="button"
            variant="cta"
            onClick={() =>
              open('ENTERPRISE_CONTACT', {
                reason: 'enterprise_plan_or_project',
              })
            }
          >
            {swingContent.action.custom.action}
          </Button>
        </article>
      </section>
    </div>
  );
}
